/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeviceFirmwareUpdateDelete
 */
export interface DeviceFirmwareUpdateDelete {
    /**
     * 
     * @type {string}
     * @memberof DeviceFirmwareUpdateDelete
     */
    blob_name: string;
}

/**
 * Check if a given object implements the DeviceFirmwareUpdateDelete interface.
 */
export function instanceOfDeviceFirmwareUpdateDelete(value: object): value is DeviceFirmwareUpdateDelete {
    if (!('blob_name' in value) || value['blob_name'] === undefined) return false;
    return true;
}

export function DeviceFirmwareUpdateDeleteFromJSON(json: any): DeviceFirmwareUpdateDelete {
    return DeviceFirmwareUpdateDeleteFromJSONTyped(json, false);
}

export function DeviceFirmwareUpdateDeleteFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceFirmwareUpdateDelete {
    if (json == null) {
        return json;
    }
    return {
        
        'blob_name': json['blob_name'],
    };
}

export function DeviceFirmwareUpdateDeleteToJSON(json: any): DeviceFirmwareUpdateDelete {
    return DeviceFirmwareUpdateDeleteToJSONTyped(json, false);
}

export function DeviceFirmwareUpdateDeleteToJSONTyped(value?: DeviceFirmwareUpdateDelete | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'blob_name': value['blob_name'],
    };
}

